import React from "react";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";
import { ErrorSite } from "misc/error"; // Assuming this is your custom fallback component

const ErrorBoundary = ({ children }) => {
    const errorHandler = (error, errorInfo) => {
        console.error(error, errorInfo);
    };

    return (
        <ReactErrorBoundary FallbackComponent={ErrorSite} onError={errorHandler}>
            {children}
        </ReactErrorBoundary>
    );
};

export default ErrorBoundary;
